import Moment from 'moment'

export default {
    link (data) { // 0-新闻 1-专题 2-直播 3-视频 4-外链 5-图集 6-频道 21-论坛
        const flag = data.flag
        const id = data.itemId || data.relateId || data.id

        if (flag === 1) {
            return `/subject/${id}`
        } else if (flag === 2) {
            return `/live/${id}`
        } else if (flag === 3) {
            return `/video/${id}`
        } else if (flag === 4) {
            return data.itemExternalUrl || data.relateValue || data.linkUrl
        } else if (flag === 5) {
            return `/atlas/${id}`
        } else if (flag === 6) {
            return `/channel/${id}`
        } else if (flag === 21) {
            return `/forum/${id}`
        } else if (id) {
            return `/news/${id}`
        } else {
            return ''
        }
    },
    //格式化内容
    filterContent (data) {
        return data ? data.replace(/<(?:.|\s)*?>/g, '').replace(/[\n\r]/g, "<br/>").replace(/↵/g, "<br/>").replace(/\s/g, '&nbsp') : '';
    },
    label (label) {
        return ['', '活动', '图集', '直播', '直播', '直播', '直播'][label]
    },
    number: {
        numToTens (num) {
            return num < 10 ? `0${num}` : `${num}`
        }
    },
    videoTime (timestamp) {
        if (!timestamp) {
            return '';
        }
        let time = parseInt(timestamp);
        return time >= 60 ? Math.floor(time / 60) < 10 ? '0' + Math.floor(time / 60) + ':' + (time % 60 < 10 ? '0' + time % 60 : time % 60) : Math.floor(time / 60) + ':' + (time % 60 < 10 ? '0' + time % 60 : time % 60) : (time < 10 ? '00:0' + time : '00:' + time);
    },
    date: {
        rangeDate (start, end) {
            const startTime = Moment(start).format('YYYY/MM/DD')
            const endTime = Moment(end).format('YYYY/MM/DD')
            if (startTime === endTime) {
                return `${startTime}`
            } else if (Moment(start).format('YYYY/MM') === Moment(end).format('YYYY/MM')) {
                return `${startTime}-${Moment(end).format('DD')}`
            } else if (Moment(start).format('YYYY') === Moment(end).format('YYYY')) {
                return `${startTime}-${Moment(end).format('MM/DD')}`
            } else {
                return `${startTime}-${endTime}`
            }
        },
        rangeMin (start, end, type) {
            const startTime = type === 'zh' ? Moment(start).format('YYYY年MM月DD日 HH:mm') : Moment(start).format('YYYY/MM/DD HH:mm')
            const endTime = type === 'zh' ? Moment(end).format('YYYY年MM月DD日 HH:mm') : Moment(end).format('YYYY/MM/DD HH:mm')
            if (startTime.split(' ')[0] === endTime.split(' ')[0]) {
                return `${startTime}-${endTime.split(' ')[1]}`
            } else {
                return `${startTime}-${endTime}`
            }
        }
    }
}
